/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { POAMDto } from './POAMDto';
import {
    POAMDtoFromJSON,
    POAMDtoFromJSONTyped,
    POAMDtoToJSON,
    POAMDtoToJSONTyped,
} from './POAMDto';

/**
 * 
 * @export
 * @interface POAMListResponse
 */
export interface POAMListResponse {
    /**
     * 
     * @type {Array<POAMDto>}
     * @memberof POAMListResponse
     */
    data?: Array<POAMDto>;
    /**
     * 
     * @type {number}
     * @memberof POAMListResponse
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof POAMListResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof POAMListResponse
     */
    pageSize?: number;
}

/**
 * Check if a given object implements the POAMListResponse interface.
 */
export function instanceOfPOAMListResponse(value: object): value is POAMListResponse {
    return true;
}

export function POAMListResponseFromJSON(json: any): POAMListResponse {
    return POAMListResponseFromJSONTyped(json, false);
}

export function POAMListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): POAMListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(POAMDtoFromJSON)),
        'total': json['total'] == null ? undefined : json['total'],
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}

export function POAMListResponseToJSON(json: any): POAMListResponse {
    return POAMListResponseToJSONTyped(json, false);
}

export function POAMListResponseToJSONTyped(value?: POAMListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(POAMDtoToJSON)),
        'total': value['total'],
        'page': value['page'],
        'pageSize': value['pageSize'],
    };
}

